import { ActivatedRoute } from '@angular/router';
var RedirectComponent = (function () {
    function RedirectComponent(route) {
        this.route = route;
        var target = this.route.snapshot.data['target'];
        if (target === 'admin') {
            window.location.href = 'https://adminv2.back2action.de';
        }
    }
    return RedirectComponent;
}());
export { RedirectComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/redirect/redirect.component.ts.pre-build-optimizer.js